services.factory('Utils', ['$timeout', '$q', 'ServerTimeService', 'constants',
    function ($timeout, $q, ServerTimeService, Const) {

        function noop() {
        }

        return {
            noop: noop,
            wait: function (duration) {
                return function (data) {
                    return $timeout(duration || 1000)
                        .then(function () {
                            return data;
                        })
                }
            },

            formatTradingTimes: function (clientTimezone, tradingTimes) {

                function parseTime(time) {
                    return {
                        hour: time.split(':')[0],
                        minute: time.split(':')[1]
                    }
                }

                function createTime(serverTime, day, range, timezone) {
                    var _time = parseTime(range);

                    moment.prototype.toUnix = function () {
                        return this.unix() + (this.utcOffset() * 60)
                    };

                    return new moment
                        .utc(serverTime)
                        .weekday(day)
                        .startOf('day')
                        .hour(_time.hour)
                        .minute(_time.minute)
                        .utcOffset(timezone);
                }


                function addDay(data, day) {
                    if (!data.hasOwnProperty(day)) {
                        data[day] = [];
                    }
                }

                function addRange(data, day, start, stop) {
                    var _start = (typeof start === "object") ? start.format("HH:mm") : start,
                        _stop = (typeof stop === "object") ? stop.format("HH:mm") : stop;

                    data[day].push([_start, _stop]);
                }

                function startOfDay(momentObj) {
                    return momentObj
                        .clone()
                        .startOf('day')
                        .toUnix();
                }

                function formatTimes(serverTimezone, clientTimezone, times) {
                    var serverTime = ServerTimeService.time,
                        timesRes = {};

                    Object.keys(times).forEach(function (day) {
                        var ranges = times[day];

                        ranges.forEach(function (range) {
                            var startRange = createTime(serverTime, day, range[0], serverTimezone),
                                stopRange = createTime(serverTime, day, range[1], serverTimezone),
                                newStartRange = createTime(serverTime, day, range[0], clientTimezone),
                                newStopRange = createTime(serverTime, day, range[1], clientTimezone);

                            if (startOfDay(newStartRange) < startOfDay(startRange) && startOfDay(newStopRange) < startOfDay(stopRange)) {

                                //move range to prev day
                                addDay(timesRes, newStartRange.day());
                                addRange(timesRes, newStartRange.day(), newStartRange, newStopRange);

                            } else if (startOfDay(newStartRange) < startOfDay(startRange) && startOfDay(newStopRange) === startOfDay(stopRange)) {

                                //create new range on prev day
                                addDay(timesRes, newStartRange.day());
                                addRange(timesRes, newStartRange.day(), newStartRange, "23:59");

                                if (newStopRange.format("HH:mm") !== "00:00") {

                                    //create new range on today
                                    addDay(timesRes, startRange.day());
                                    addRange(timesRes, startRange.day(), "00:00", newStopRange);
                                }

                            } else if (startOfDay(newStartRange) > startOfDay(startRange) && startOfDay(newStopRange) > startOfDay(stopRange)) {

                                //move range to next day
                                addDay(timesRes, newStartRange.day());
                                addRange(timesRes, newStartRange.day(), newStartRange, newStopRange);

                            } else if (startOfDay(newStopRange) > startOfDay(stopRange) && startOfDay(newStartRange) === startOfDay(startRange)) {

                                //create new range on next day
                                addDay(timesRes, newStartRange.day());
                                addRange(timesRes, newStartRange.day(), newStartRange, "23:59");

                                if (newStopRange.format("HH:mm") !== "00:00") {

                                    //create new range on today
                                    addDay(timesRes, newStopRange.day());
                                    addRange(timesRes, newStopRange.day(), "00:00", newStopRange);
                                }
                            } else {
                                //range which stays on today
                                addDay(timesRes, startRange.day());
                                addRange(timesRes, startRange.day(), newStartRange, newStopRange);
                            }
                        });

                    });

                    return timesRes;
                }

                return formatTimes(0, clientTimezone, tradingTimes);
            },
            runChain: function (chain, method) {

                var p = $q(function (resolve, reject) {
                    resolve();
                });

                return chain.reduce(function (promise, fn) {
                    return promise.then(method ? fn[method] : fn);
                }, p);
            },
            toBoolean: function (value) {
                return value ? true : false;
            },

            fromBoolean: function (value) {
                return value ? 1 : 0;
            },
            formRevalidate: function (form, isDropdowns) {
                Object.keys(form)
                    .filter(function (key) {
                        return isDropdowns
                            ? !key.match(/^\$/)
                            : (!key.match(/^\$/) && form[key].$viewValue)
                    })
                    .forEach(function (key) {
                        form[key].$setDirty();
                        form[key].$setTouched();
                    });
            },
            //looking for currency based on country
            getCurrencyByCountry: function (countryCode, countries, currencies) {

                if (!countryCode) return currencies[0].currency;

                var countryByCurrency = _.find(countries, {code: countryCode});
                if (!countryByCurrency) return undefined;

                var currency = _.find(currencies, {currency: countryByCurrency.currency});

                function isCurrency(currency) {
                    return _.find(currencies, {currency: currency})
                }

                if (currency) return currency.currency;

                if (countryCode === 'GB') {
                    if (isCurrency('EUR')) return 'EUR';
                    if (isCurrency('USD')) return 'USD';
                }

                return countryByCurrency.currency;
            },
            capitalize: function (val) {
                return val
                    .toLowerCase()
                    .charAt(0)
                    .toUpperCase() + val.toLowerCase().slice(1)
            },
            toCamelCase: function (val) {
                var self = this;
                var tmp = val.split(' ')
                    .reduce(function (prev, next) {
                        return prev.concat(self.capitalize(next))
                    }, '');
                return tmp.charAt(0).toLowerCase() + tmp.slice(1);
            },
            toSnakeCase: function (val) {
                return val.replace(/\s/g, '_').toLowerCase();
            },
            getDateRange: function (range) {

                function getStartTime(frame) {
                    return moment().utc(ServerTimeService.time).startOf(frame);
                }

                function getRangeDay(days) {
                    return getStartTime('day').subtract(days, 'day');
                }

                function getRangeWeek(weeks) {
                    return getStartTime('isoweek').subtract(weeks, 'week');
                }

                function getRangeMonth(months) {
                    return getStartTime('month').subtract(months, 'month');
                }

                var rangeParsed = range.split(' '),
                    returnDate;

                if (rangeParsed[1].toLowerCase().match('day')) {
                    returnDate = getRangeDay(parseInt(rangeParsed[0], 10));
                }
                if (rangeParsed[1].toLowerCase().match('week')) {
                    returnDate = getRangeWeek(parseInt(rangeParsed[0], 10));
                }
                if (rangeParsed[1].toLowerCase().match('month')) {
                    returnDate = getRangeMonth(parseInt(rangeParsed[0], 10));
                }

                return returnDate.unix();
            },
            setTimeRange: function (range) {
                var startTime,
                    endTime,
                    self = this;

                switch (range) {
                    case 'day':
                        startTime = self.getDateRange('0 days');
                        break;
                    case 'threedays':
                        startTime = self.getDateRange('2 days');
                        break;
                    case 'week':
                        startTime = self.getDateRange('0 week');
                        break;
                    case'month':
                        startTime = self.getDateRange('0 month');
                        break;
                    case 'threemonths':
                        startTime = self.getDateRange('2 month');
                        break;
                    case 'all':
                        startTime = 1;
                        break;
                }

                endTime = parseInt(ServerTimeService.time / 1000, 10);

                return ({
                    Start: startTime,
                    End: endTime
                })
            },
            generateForm: function (url, data) {
                var form = document.createElement('form');
                form.id = 'form3ds';
                form.method = 'POST';
                form.action = url;
                data.forEach(function (item) {
                    var input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = item.name;
                    input.value = item.value;
                    form.appendChild(input);
                });
                return form;
            },
            insertDocumentScripts: function (doc, data) {
                var header = doc.getElementsByTagName('body')[0];
                data
                    .filter(function (item) {
                        return item.name === 'script'
                    })
                    .forEach(function (item) {
                        var scriptEl = document.createElement('script');
                        scriptEl.src = item.value;
                        header.appendChild(scriptEl)
                    });
            },
            getURLParameterByName: function (name, url) {
                if (!url) url = window.location.href;
                name = name.replace(/[\[\]]/g, "\\$&");
                var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return '';
                return decodeURIComponent(results[2].replace(/\+/g, " "));
            },
            getDiffInPoints: function (num1, num2, digits) {
                return Math.round(Math.abs(num1 - num2) * Math.pow(10, digits));
            },
            getReferralString: function () {
                //return location.search.replace('?', '').split('&');
                return location.search.replace('?', '')
                    .split('&')
                    .filter(function (key) {
                        return !key.match(/^token=|^etoken|^action=/)
                    })
                    .join('|')
            },

            getUrlRemarketing: function () {
                var params = this.getURLParameterByName('remarketing');
                if (params) return params;
            },
            decimalRound: function (value, digits) {
                var _value = Math.abs(value) * Math.pow(10, digits);
                var result = Math.floor(Number(_value)) / Math.pow(10, digits);
                return value >= 0 ? result : result * -1;
            },

            createLinkByLang: function (key, lang, defaultKey) {
                var url = _.get(Const, key + '.' + lang);
                if (!url) {
                    url = _.get(Const, defaultKey)
                }
                return url ? url : _.get(Const, key);
            },

            extractDigits: function (value) {
                return value.toString().match(/\./)
                    ? value.toString().split(/\./).pop().length
                    : 0
            }
        }

    }]);
